import { type ConversationStatus, type ConversationData, getCategoryScore } from '@terros/common'
import { useWorkflow } from '../workflow'
import { formatDate } from '../formatting'

export const stringifyConvoStatus = (status: ConversationStatus): string => {
  switch (status) {
    case 'Flagged':
      return 'Flagged'
    case 'GradingFailed':
      return 'Grading Failed'
    case 'TranscribeFailed':
      return 'Transcribe Failed'
    default:
      return status
  }
}

export const stringifySpeaker = (speaker: number): string => {
  return `Speaker ${speaker + 1}`
}

export const useConversationStageTitle = (convo: ConversationData): string | undefined => {
  const { data: workflow } = useWorkflow(convo.workflowId)
  if (workflow && convo.workflowStageId) {
    const stage = workflow.stagesMap.get(convo.workflowStageId)
    if (stage) return stage.name
  }
}

export const getConversationDate = (date: number): string => {
  return formatDate(date, { format: 'MMM d, yyyy h:mm a' })
}

/**
 * Returns a 0–1 score for a specific rubric category matched by title (case-insensitive).
 * Returns undefined if the category is not found or has no possible points.
 */
export const getCategoryScorePercentage = (
  rubric: ConversationData['rubric'],
  categoryTitle?: string
): number | undefined => {
  if (!rubric || !categoryTitle) return
  const category = rubric.find((cat) => cat.title === categoryTitle)
  if (!category) return
  const { score, possible } = getCategoryScore(category)
  if (possible === 0) return
  return Math.max(Math.min(score / possible, 1), 0)
}
